import { config } from '@yola/ws-sdk';

const getIconPreviewUrl = (params) => {
  const searchParams = new URLSearchParams(params);
  return `${config.accessors.getAPIUrl()}icons/preview/?${searchParams.toString()}`;
};

export default getIconPreviewUrl;
